import React from 'react';
import { PieChart, Pie, Cell } from 'recharts';

export interface SourceHealthChartProps {
  label: string,
  errored: number,
  delayed: number,
  all: number
}

export const SourceHealthChart: React.FC<SourceHealthChartProps> = ({ label, errored, delayed, all }) => {

  const erroredData = [
    { name: "Healthy", value: all - errored },
    { name: "Error", value: errored }
  ]

  const delayedData = [
    { name: "Healthy", value: all - delayed },
    { name: "Delayed", value: delayed }
  ]

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index, value }: any) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
  
    return (
      <text x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central">
        {value}
      </text>
    );
  };

  return (
    <>
      <h4>{label}</h4>
      <PieChart width={250} height={250}>
        <Pie data={erroredData} dataKey="value" cx="50%" cy="50%" outerRadius={60} label={renderCustomizedLabel} labelLine={false}>
          <Cell key="cell-0" fill="#1769aa" />
          <Cell key="cell-1" fill="#ab003c" />
        </Pie>
        <Pie data={delayedData} dataKey="value" cx="50%" cy="50%" innerRadius={60} outerRadius={110} label={renderCustomizedLabel} labelLine={false}>
          <Cell key="cell-0" fill="#2196f3" />
          <Cell key="cell-1" fill="#ff3d00" />
        </Pie>
      </PieChart>
    </>
  );
}